<template>
  <div class="diversity-inclusion">
    <!-- Header Section -->
    <div class="header">
      <div class="header-content">
        <h1>Diversidad e Inclusión</h1>
        <p>
          Nuestros Programas están dirigidos a impulsar y destacar a todo nuestro Talento. Abrazamos la diversidad y
          trabajamos en torno a 8 ejes:
        </p>

        <div class="pillars">
          <div class="pillar-row">
            <div class="pillar">Liderazgo Femenino</div>
            <div class="pillar">Nuevas Masculinidades</div>
          </div>
          <div class="pillar-row">
            <div class="pillar">Población Vulnerable</div>
            <div class="pillar">Comunidad LGBTIQ+</div>
          </div>
          <div class="pillar-row">
            <div class="pillar">Nuevas Generaciones</div>
            <div class="pillar">Personas Adulto Mayores</div>
          </div>
          <div class="pillar-row">
            <div class="pillar">Multiculturalidad</div>
            <div class="pillar">Personas con Discapacidad</div>
          </div>
        </div>
      </div>
      <div class="header-image">
        <img src="../../../assets/newlanding/Landing/2-personas.png" alt="Personas diversas sonriendo" />
      </div>
    </div>

    <!-- Programas Section -->
    <h2 class="programs-title">Nuestros Programas</h2>

    <div class="programs">
      <div class="program">
        <h3 class="program-title">Incluye</h3>
        <p class="program-description">
          Conectamos e insertamos a población vulnerable a la empresa desde hace más de 10 años. Aseguramos un trabajo
          digno en un ambiente seguro donde todos y todas pueden crecer.
        </p>
      </div>

      <div class="program">
        <h3 class="program-title">LIFE</h3>
        <p class="program-description">
          Programa de Liderazgo Femenino para las mujeres de la organización, donde promovemos espacios de equidad, para
          así convertirlas en agentes de cambio.
        </p>
      </div>

      <div class="program">
        <h3 class="program-title">Ellos</h3>
        <p class="program-description">
          Programa de Nuevas Masculinidades dirigido a hombres líderes, donde fomentamos espacios de diálogo y educación
          en sesgos y cultura de equidad.
        </p>
      </div>

      <div class="program">
        <h3 class="program-title">Conectando Empleabilidad</h3>
        <p class="program-description">
          Charlas cortas dictadas por colaboradores/as, para brindar herramientas de empleabilidad a la comunidad.
        </p>
      </div>

      <div class="program">
        <h3 class="program-title">A tu Lado</h3>
        <p class="program-description">
          Programa de Acompañamiento Psicológico de la mano de especialistas para ayudar a nuestro equipo a superar
          episodios de estrés, ansiedad, depresión, etc.
        </p>
      </div>

      <div class="program">
        <h3 class="program-title">Basta Ya</h3>
        <p class="program-description">
          Programa de Prevención de Violencia, Acoso Sexual y Hostigamiento laboral. Ponemos a disposición herramientas
          que ayudan a sanar episodios de violencia.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiversidadInclusion",
  data() {
    return {
      // Any reactive data can be added here if needed
    };
  },
};
</script>

<style scoped>
.diversity-inclusion {
  /* font-family: Arial, sans-serif; */
  max-width: 1200px;
  margin: 0 auto;
  color: #333;
}

.header {
  display: flex;
  background-color: #2800c8;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
}

.header-content {
  flex: 1;
  padding: 32px;
  color: white;
}

.header-image {
  width: 50%;
  overflow: hidden;
}

.header-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

h1 {
  font-size: 28px;
  margin-bottom: 16px;
  font-weight: bold;
}

h2.programs-title {
  color: #2800c8;
  font-size: 24px;
  margin-bottom: 24px;
  font-weight: bold;
}

.pillars {
  margin-top: 20px;
}

.pillar-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.pillar {
  background-color: white;
  color: #2800c8;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  flex: 1;
  text-align: center;
}

.programs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.program {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 20px;
}

.program-title {
  color: #2800c8;
  font-size: 18px;
  margin-bottom: 12px;
  font-weight: bold;
}

.program-description {
  font-size: 14px;
  line-height: 1.5;
}

/* Responsive design */
@media (max-width: 900px) {
  .header {
    flex-direction: column;
  }

  .header-image {
    width: 100%;
    height: 300px;
  }

  .programs {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .pillar-row {
    flex-direction: column;
  }

  .programs {
    grid-template-columns: 1fr;
  }
}
</style>
